import {z} from 'zod';

export const DeliveryNoteListBulkEditFormSchema = z.object({
  warehouse: z.object({
    isWarehouseEnabled: z.boolean(),
    warehouseId: z.string().nullish(),
  }),
  currency: z.object({
    isCurrencyEnabled: z.boolean(),
    currency: z.string().nullish(),
  }),
  invoiceNumber: z.object({
    isInvoiceNumberEnabled: z.boolean(),
    invoiceNumber: z.string().nullish(),
  }),
  invoiceIssueDate: z.object({
    isInvoiceIssueDateEnabled: z.boolean(),
    invoiceIssueDate: z.date().nullish(),
  }),
});

export type DeliveryNoteListBulkEditForm = z.infer<typeof DeliveryNoteListBulkEditFormSchema>;
